export interface IGenericDynamicKeys<T> {
  [key: number]: T;
}